export default "<p>add-cargo works!</p>\n"